import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { useNavigate, useLocation } from "react-router-dom";
import NoMatchSection from "../Inspecie-Transfer/no-match-section";
import StockMatchSummary from "../Inspecie-Transfer/stock-match-chart";
import GuestHeader from "./guest-header";
import EmailVerificationModal from "../../Components/email-link-popup/email-link-popup";
import { debounce } from "lodash";
import { useToast } from "../../Utils/toastContext";

const LoadStocksGuest = () => {
  const { showToast } = useToast();
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, settotalCount] = useState(0);
  const [totalPages, settotalPages] = useState(0);
  const [hinNumber, setHinNumber] = useState("");
  const [isFetch, setIsFetch] = useState(false);
  const [isFetchStrategy, setIsFetchStrategy] = useState(false);
  const [isFetchStrategyCheck, setIsFetchStrategyCheck] = useState(false);
  const [isfetchExist, setIsFetchExist] = useState(false);
  const [isMatchFound, setIsMatchFound] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPortfolio, setIsLoadingPortfolio] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [nearestStrategies, setNearestStrategies] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const [manualEntryVisible, setManualEntryVisible] = useState(false);
  const [manualStockCode, setManualStockCode] = useState("");
  const [manualQuantity, setManualQuantity] = useState("");
  const [manualStockName, setManualStockName] = useState("");
  const [manualStockList, setManualStockList] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [matchedStocks, setMatchedStocks] = useState([]);
  const [unmatchedStocks, setUnmatchedStocks] = useState([]);
  const [portfolioAccounttableData, setPortfolioAccounttableData] = useState(
    []
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [showRecords, setShowRecords] = useState(10);
  const [filterText, setFilterText] = useState("created_at");
  const [editIndex, setEditIndex] = useState(null);
  const [editCode, setEditCode] = useState("");
  const [editQuantity, setEditQuantity] = useState("");
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const [manualPurchasedDate, setManualPurchasedDate] = useState("");
  const [editPurchasedDate, setEditPurchasedDate] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);
  const [email, setEmail] = useState("");
  const [file, setFile] = useState(null);
  const [userName, setUserName] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [focus, setFocus] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [stockData, setStockData] = useState([]);
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const portfolioAccountheaders = [
    { label: "Investment ID", key: "investment ID" },
    { label: "Investment Product Name", key: "productName" },
    { label: "Matched %", key: "Matched" },
    { label: "Minimum Investment Amount", key: "Matched" },
  ];
  const handleshowRecord = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const handleSort = (key) => {
    setFilterText(key);
  };
  function formatDateToDDMMYYYY(dateStr) {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  }
  const handleAddManualStock = () => {
    if (!manualStockCode || !manualQuantity || !manualPurchasedDate) return;

    const newStock = {
      code: manualStockCode.toUpperCase(),
      stock_name: manualStockName || "Custom Stock",
      quantity: parseInt(manualQuantity),
      purcahsed_date: manualPurchasedDate,
    };

    setManualStockList([...manualStockList, newStock]);
    setManualStockCode("");
    setManualQuantity("");
    setManualStockName("");
    setManualPurchasedDate("");
    setIsFetchStrategyCheck(false);
    setIsFetchStrategy(false);
  };
  const handleEdit = (index) => {
    const item = manualStockList[index];
    setEditCode(item.code);
    setEditQuantity(item.quantity);
    setEditPurchasedDate(item.purcahsed_date || "");
    setEditIndex(index);
  };

  const handleUpdateSave = (index) => {
    const updatedList = [...manualStockList];
    updatedList[index] = {
      ...updatedList[index],
      code: editCode.toUpperCase(),
      quantity: Number(editQuantity),
      purcahsed_date: editPurchasedDate,
    };
    setManualStockList(updatedList);
    setEditIndex(null);
    setIsFetchStrategyCheck(false);
    setIsFetchStrategy(false);
  };

  const handleFinalSubmit = () => {
    setIsSubmitted(true);
  };
  const handleDeleteManualStock = (indexToDelete) => {
    const updatedList = manualStockList.filter(
      (_, index) => index !== indexToDelete
    );
    setManualStockList(updatedList);
    setIsFetchStrategyCheck(false);
    setIsFetchStrategy(false);
  };
  const handlePortfolioClick = (portfolio) => {
    setSelectedPortfolio(portfolio);
    setIsModalOpen(true);
  };

  const handleSendLink = () => {
    // Simulate email send
    if (email && /\S+@\S+\.\S+/.test(email)) {
      // TODO: Replace this with API call
      setEmailSent(true);
    }
  };
  const fetchStockApi = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `https://inspecie.caprock.com.au/api/v1/inspecie/create-request`;
    // const apiUrl = `${BASE_URL}/api/v1/inspecie/create-request`;

    const bodyData = {
      hin_number: hinNumber,
      type: "string",
      stockjson: manualStockList,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const fetchStrategiesApi = async (id) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `https://inspecie.caprock.com.au/api/v1/inspecie/upload-request?page_size=${showRecords}&page=${currentPage}&search_query=${searchQuery}`;
    // const apiUrl = `${BASE_URL}/api/v1/inspecie/upload-request?page_size=${showRecords}&page=${currentPage}&search_query=${searchQuery}`;
    const bodyData = {
      id: id,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleFetchStocks = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        setRequestId(null);
        const response = await fetchStockApi();
        if (response.status == "success") {
          // setRequestId(response.data.id);
          setRequestId(29);
        } else {
          setRequestId(null);
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        setIsFetchStrategy(false);
        setIsFetchStrategyCheck(false);
        setRequestId(null);
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [hinNumber, manualStockList, showRecords, currentPage, searchQuery] // Dependencies
  );
  const fetchStocks = async (id) => {
    let toastMessage = null;
    try {
      setIsLoadingPortfolio(true);
      const responseStrategies = await fetchStrategiesApi(29);
      if (responseStrategies.status == "success") {
        if (
          !manualEntryVisible &&
          responseStrategies.data.request_stocks.length > 0
        ) {
          setIsFetch(true);
          setIsFetchExist(true);
          setStockData(responseStrategies.data.request_stocks);
        }
        if (responseStrategies.data.recommended_strategies.length > 0) {
          // setPortfolioAccounttableData(
          //   responseStrategies.data.recommended_strategies
          // );
          // setIsMatchFound(true);
          // settotalPages(
          //   responseStrategies.pagination.recommended_strategies.total_pages
          // );
          // settotalCount(
          //   responseStrategies.pagination.recommended_strategies.total_items
          // );

          // unmatch
          setPortfolioAccounttableData([]);
          setIsMatchFound(true);
          setNearestStrategies(
            responseStrategies.data.nearest_matched_strategies
          );
          setIsMatchFound(false);
          settotalPages(
            responseStrategies.pagination.nearest_matched_strategies.total_pages
          );
          settotalCount(
            responseStrategies.pagination.nearest_matched_strategies.total_items
          );
        } else {
          setPortfolioAccounttableData([]);
          setIsMatchFound(true);
          setNearestStrategies(
            responseStrategies.data.nearest_matched_strategies
          );
          setIsMatchFound(false);
          settotalPages(
            responseStrategies.pagination.nearest_matched_strategies.total_pages
          );
          settotalCount(
            responseStrategies.pagination.nearest_matched_strategies.total_items
          );
        }
        setMatchedStocks(responseStrategies.data.matched_stocks);
        setUnmatchedStocks(responseStrategies.data.unmatched_stocks);
        setIsFetchStrategy(true);
        setIsFetchStrategyCheck(true);
      } else {
        toastMessage = { message: responseStrategies.message, type: "error" };
      }
    } catch (err) {
      setIsFetchStrategy(false);
      setIsFetchStrategyCheck(false);
      setPortfolioAccounttableData([]);
      setNearestStrategies([]);
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setTimeout(() => {
        setIsLoadingPortfolio(false);
        if (toastMessage) {
          showToast(toastMessage.message, toastMessage.type);
        }
      }, 300); // Small delay if needed
    }
  };
  const formatDateForFilterNew = (dateString) => {
    const date = new Date(dateString);

    // Extract year, month, and date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 since months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}/${month}/${year}`; // Format as yyyy-dd-mm
  };
  useEffect(() => {
    if (requestId != null) {
      fetchStocks(29);
    }
  }, [showRecords, currentPage, requestId, searchQuery]);
  return (
    <div className="px-4 py-2">
      <GuestHeader displayName="" />

      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      <div className="bg-white mt-4 rounded-md ">
        <div className="w-full max-w-4xl mx-auto px-4 py-4">
          <div className="flex flex-col items-center text-center gap-2 mb-6">
            <div className="flex items-center gap-2">
              <img
                src="/stock-black.svg"
                alt="Company Logo"
                className="w-6 h-6"
              />
              <h2 className="text-lg md:text-xl font-semibold text-gray-800 dark:text-gray-200">
                Add Your Trading Stocks
              </h2>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-400 max-w-md">
              Add your stocks manually or using your HIN number to fetch them
              automatically. This helps us personalize and match recommended
              portfolios for you.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Auto Fetch Section */}
            <div className="bg-white dark:bg-[#1A1A1A] shadow-md rounded-xl p-6 border border-gray-200 dark:border-[#333]">
              <label
                htmlFor="hinNumber"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
              >
                Enter HIN Number to Auto-Fetch Stocks
              </label>
              <input
                id="hinNumber"
                name="hinNumber"
                type="text"
                value={hinNumber}
                placeholder="e.g. 1234567890"
                onChange={(e) => {
                  setHinNumber(e.target.value);
                  setIsFetchExist(false);
                  setIsFetchStrategy(false);
                  setManualEntryVisible(false);
                  setIsFetchStrategyCheck(false);
                }}
                className="w-full rounded-md h-11 px-4 py-2 border border-gray-300 dark:border-[#4F4F4F] dark:bg-[#101010] dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-black"
              />

              <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  handleFetchStocks(e);
                }}
                disabled={
                  !manualEntryVisible && hinNumber !== "" && !isfetchExist
                    ? false
                    : true
                }
                className={`mt-4 w-full text-sm font-medium py-2 px-4 rounded-full flex items-center justify-center gap-2 transition ${
                  !manualEntryVisible && hinNumber !== "" && !isfetchExist
                    ? "bg-black text-white"
                    : "bg-gray-300 text-gray-600"
                }`}
              >
                {/* SVG icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M6 4v16m12-8v8m-6-12v12"
                  />
                </svg>
                Fetch Stocks
              </button>
            </div>

            {/* Manual Entry Section */}
            <div className="bg-white dark:bg-[#1A1A1A] shadow-md rounded-xl p-6 border border-gray-200 dark:border-[#333]">
              <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-4">
                Prefer to Add Manually?
              </p>
              <button
                disabled={!isfetchExist ? false : true}
                onClick={() => {
                  setManualEntryVisible((prev) => !prev);
                  setIsFetch(false);
                  setManualStockList([]);
                  setManualStockCode("");
                  setManualQuantity("");
                  setIsFetchExist(false);
                  setIsFetchStrategy(false);
                }}
                className={`w-full flex items-center justify-center gap-2 text-sm font-medium py-2 px-4 rounded-full transition-colors duration-300 ${
                  hinNumber == "" && !isfetchExist
                    ? "bg-black text-white"
                    : "bg-gray-300 text-gray-600"
                }`}
              >
                {manualEntryVisible ? (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                    Cancel
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3l-8.5 8.5L10 14l.5-3.5 8-8z"
                      />
                    </svg>
                    Add Manually
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      {manualEntryVisible && hinNumber == "" && (
        <div className="mt-4 bg-white dark:bg-[#1e1e1e] shadow-lg rounded-xl py-4 px-10">
          <h3 className="text-base md:text-lg font-semibold text-black dark:text-white mb-3">
            Stock Holdings
          </h3>

          <div className="overflow-x-auto max-h-[60vh]">
            <table className="min-w-full text-sm text-left border border-gray-200 dark:border-gray-700">
              <thead className="bg-[#ECFAFF] text-[#005A9C] text-xs md:text-sm">
                <tr>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Code
                  </th>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Quantity
                  </th>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Purchased Date
                  </th>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-center">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody className="text-black dark:text-gray-200">
                {/* Inline Input Row */}
                <tr className="bg-gray-50 dark:bg-[#2a2a2a]">
                  <td className="px-4 py-2 border border-gray-300 dark:border-gray-700">
                    <input
                      type="text"
                      value={manualStockCode}
                      onChange={(e) => setManualStockCode(e.target.value)}
                      placeholder="Stock Code"
                      className="w-full px-2 py-1 text-sm rounded-md border dark:bg-[#101010] dark:text-white border-gray-300 dark:border-[#4F4F4F]"
                    />
                  </td>
                  <td className="px-4 py-2 border border-gray-300 dark:border-gray-700">
                    <input
                      type="number"
                      value={manualQuantity}
                      onChange={(e) => setManualQuantity(e.target.value)}
                      placeholder="Qty"
                      className="w-full rounded-md px-2 py-1 text-sm rounded border dark:bg-[#101010] dark:text-white border-gray-300 dark:border-[#4F4F4F]"
                    />
                  </td>
                  <td className="px-4 py-2 border border-gray-300 dark:border-gray-700">
                    <input
                      type="date"
                      value={manualPurchasedDate}
                      onChange={(e) => setManualPurchasedDate(e.target.value)}
                      className="w-full rounded-md px-2 py-1 text-sm border dark:bg-[#101010] dark:text-white border-gray-300 dark:border-[#4F4F4F]"
                    />
                  </td>
                  <td className="w-40 px-4 py-2 border border-gray-300 dark:border-gray-700 text-center">
                    <button
                      onClick={handleAddManualStock}
                      className="bg-[#005A9C] hover:bg-[#004b85] text-white text-xs font-medium py-1 px-3 rounded-full"
                    >
                      Add
                    </button>
                  </td>
                </tr>

                {/* Existing added manual rows */}
                {manualStockList.map((item, index) => (
                  <tr
                    key={index}
                    className="hover:bg-[#f0faff] dark:hover:bg-[#2a2a2a] transition-colors"
                  >
                    {editIndex === index ? (
                      <>
                        {/* Code Input */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-[#ECFAFF]">
                          <input
                            type="text"
                            value={editCode}
                            onChange={(e) => setEditCode(e.target.value)}
                            className="w-full px-2 py-1 text-sm rounded-md border border-gray-300 dark:border-gray-600 dark:bg-[#101010] dark:text-white"
                          />
                        </td>

                        {/* Quantity Input */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          <input
                            type="number"
                            value={editQuantity}
                            onChange={(e) => setEditQuantity(e.target.value)}
                            className="w-full px-2 py-1 text-sm rounded-md border border-gray-300 dark:border-gray-600 dark:bg-[#101010] dark:text-white"
                          />
                        </td>

                        {/* Purchased Date Input */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          <input
                            type="date"
                            value={editPurchasedDate}
                            onChange={(e) =>
                              setEditPurchasedDate(e.target.value)
                            }
                            className="w-full px-2 py-1 text-sm rounded-md border border-gray-300 dark:border-gray-600 dark:bg-[#101010] dark:text-white"
                          />
                        </td>

                        {/* Action Buttons */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 text-center space-x-2">
                          <button
                            onClick={() => handleUpdateSave(index)}
                            className="bg-green-500 hover:bg-green-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                          >
                            Save
                          </button>
                          <button
                            onClick={() => setEditIndex(null)}
                            className="bg-gray-500 hover:bg-gray-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                          >
                            Cancel
                          </button>
                        </td>
                      </>
                    ) : (
                      <>
                        {/* Code Text */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-[#ECFAFF]">
                          {item.code}
                        </td>

                        {/* Quantity Text */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          {item.quantity.toLocaleString()}
                        </td>

                        {/* Purchased Date Text */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          {formatDateToDDMMYYYY(item.purcahsed_date) || "—"}
                        </td>

                        {/* Action Buttons */}
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 text-center space-x-2">
                          <button
                            onClick={() => handleEdit(index)}
                            className="bg-blue-500 hover:bg-blue-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDeleteManualStock(index)}
                            className="bg-red-500 hover:bg-red-600 text-white text-xs font-medium py-1 px-3 rounded-full"
                          >
                            Delete
                          </button>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Final Submit Button */}
          {manualStockList.length > 0 && (
            <div className="flex flex-col md:flex-row items-center justify-between mt-6 px-8 py-4 bg-[#FF5050] bg-opacity-20 shadow-md rounded-md space-y-4 md:space-y-0">
              {/* Text Section */}
              <div className="text-center md:text-left flex-1">
                <span className="block text-sm md:text-md font-medium text-black">
                  Upload your stock data to discover applicable strategies
                </span>
              </div>

              {/* Button Section */}
              <div className="text-center md:text-right">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setLoading(true);
                    handleFetchStocks(e);
                  }}
                  disabled={!isFetchStrategyCheck ? false : true}
                  className={`flex items-center justify-center space-x-2 font-medium py-2 px-4 rounded-full text-sm ${
                    !isFetchStrategyCheck
                      ? "bg-black text-white"
                      : "bg-gray-300 text-gray-600"
                  }`}
                >
                  <span>Upload Now</span>
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {isFetch && isfetchExist && (
        <div className="mt-6 bg-white dark:bg-[#1e1e1e] shadow-lg rounded-xl p-4">
          <h3 className="text-base md:text-lg font-semibold text-black mb-3">
            Stock Holdings
          </h3>

          <div className="overflow-x-auto max-h-[70vh]">
            <table className="min-w-full text-sm text-left border border-gray-200 dark:border-gray-700">
              <thead className="bg-[#ECFAFF] text-[#005A9C] text-xs md:text-sm">
                <tr>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Code
                  </th>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Stock Name
                  </th>

                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Quantity
                  </th>
                  <th className="px-4 py-2 border border-gray-300 dark:border-gray-600">
                    Purchased Date
                  </th>
                </tr>
              </thead>

              {isLoading ? (
                <tbody>
                  {[...Array(5)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="animate-pulse">
                      {[...Array(2)].map((_, colIndex) => (
                        <td key={colIndex} className="px-4 py-3">
                          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="text-black dark:text-gray-200">
                  {stockData.length > 0 ? (
                    stockData.map((row, index) => (
                      <tr
                        key={index}
                        className="hover:bg-[#f0faff] dark:hover:bg-[#2a2a2a] transition-colors"
                      >
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-[#ECFAFF]">
                          {row.asx_code}
                        </td>
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          {row.name}
                        </td>
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          {row.qty
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td className="px-4 py-2 border border-gray-200 dark:border-gray-700">
                          {formatDateForFilterNew(row.purchased_date)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="2"
                        className="text-center text-sm py-6 text-gray-500 dark:text-gray-400"
                      >
                        No results found
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>
        </div>
      )}
      {isFetchStrategy && (
        <>
          {isMatchFound && (
            <div className="font-medium bg-white mt-6 py-4 px-10 rounded-xl shadow-sm border border-gray-200 text-sm text-gray-900">
              {/* Header Section */}
              <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
                <h3 className="text-base font-semibold text-black flex items-center gap-2">
                  {/* Replace with any SVG above */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6 text-black"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 7l9-4 9 4-9 4-9-4zm0 6l9 4 9-4m-9 4v5"
                    />
                  </svg>
                  Recommended Strategies
                </h3>

                <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                  {/* Show Records */}
                  <div className="flex items-center gap-2">
                    <span className="text-gray-600">Show</span>
                    <Dropdown
                      label=""
                      options={filterOptions}
                      preselectedValue={preSelectedFilter}
                      onSelect={handleshowRecord}
                    />
                  </div>

                  {/* Search */}
                  <div className="relative w-full sm:w-auto">
                    <input
                      type="text"
                      className="pl-9 pr-3 py-1.5 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-black focus:outline-none w-full sm:w-60 text-sm"
                      placeholder="Search strategy"
                      value={searchQuery}
                      onChange={(e) => {
                        setCurrentPage(1);
                        setSearchQuery(e.target.value);
                      }}
                    />
                    <img
                      src="/search-normal.svg"
                      alt="Search"
                      className="absolute left-3 top-2 w-4 h-4 text-gray-400"
                    />
                  </div>
                </div>
              </div>

              {/* Table */}
              <div className="overflow-x-auto">
                <table className="min-w-full border-separate border-spacing-y-1 text-sm">
                  <thead className="bg-gray-100 text-gray-700">
                    <tr>
                      {portfolioAccountheaders.map((header) => (
                        <th
                          key={header.label}
                          onClick={() => handleSort(header.key)}
                          className="px-4 py-2 text-left font-medium cursor-pointer whitespace-nowrap"
                        >
                          <div className="flex items-center space-x-1">
                            <span>{header.label}</span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {isLoadingPortfolio ? (
                      [...Array(5)].map((_, i) => (
                        <tr
                          key={i}
                          className="rounded border border-gray-100 bg-white"
                        >
                          {[...Array(4)].map((_, j) => (
                            <td key={j} className="px-4 py-3">
                              <div className="h-3 bg-gray-200 rounded animate-pulse"></div>
                            </td>
                          ))}
                        </tr>
                      ))
                    ) : portfolioAccounttableData.length > 0 ? (
                      portfolioAccounttableData.map((row, index) => (
                        <tr
                          key={index}
                          className={`transition-colors border border-gray-100 ${
                            index % 2 === 0 ? "bg-white" : "bg-gray-50"
                          } hover:bg-indigo-50`}
                        >
                          <td className="px-4 py-3 whitespace-nowrap">
                            {row.ref_code}
                          </td>
                          <td
                            onClick={() => handlePortfolioClick(row)}
                            className="px-4 py-3 text-[#005A9C] hover:underline cursor-pointer whitespace-normal font-medium"
                          >
                            Caprock Model portfolio - {row.strategy_name}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap font-semibold text-emerald-600">
                            {row.overall_matching_percentage
                              ? row.overall_matching_percentage.toFixed(2) + "%"
                              : "0.00"}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            $
                            {row.overall_matching_percentage
                              ? row.minimum_investment
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              : "0.00"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={4}
                          className="px-4 py-4 text-center text-gray-500"
                        >
                          No results found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <EmailVerificationModal
                isOpen={isModalOpen}
                onClose={() => {
                  setIsModalOpen(false);
                  setEmail("");
                  setFile(null);
                  setUserName("");
                  setEmailSent(false);
                  setMobileNumber("");
                  setSelectedCode("");
                }}
                title="Access Portfolio:"
                subtitle={`Caprock Model Portfolio - ${selectedPortfolio?.strategy_name}`}
                email={email}
                setEmail={setEmail}
                emailSent={emailSent}
                file={file}
                setFile={setFile}
                userName={userName}
                setUserName={setUserName}
                selectedCode={selectedCode}
                setSelectedCode={setSelectedCode}
                focus={focus}
                setFocus={setFocus}
                mobileNumber={mobileNumber}
                setMobileNumber={setMobileNumber}
                handleSendLink={handleSendLink}
                handleCodeChange={handleCodeChange}
              />

              {/* Pagination */}
              {!isLoading && (
                <div className="flex flex-col sm:flex-row justify-between items-center mt-4 text-gray-700 text-xs gap-3">
                  <div>
                    Showing {showRecords * (currentPage - 1) + 1} to{" "}
                    {currentPage === totalPages || totalPages === 0
                      ? totalCount
                      : Math.min(showRecords * currentPage, totalCount)}{" "}
                    of {totalCount} entries
                  </div>
                  <div className="flex gap-1">
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((prev) => prev - 1)}
                      className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
                    >
                      Prev
                    </button>
                    {Array.from({ length: Math.min(totalPages, 5) }).map(
                      (_, i) => {
                        const startPage = Math.max(
                          1,
                          Math.min(totalPages - 4, currentPage - 2)
                        );
                        const page = startPage + i;
                        return (
                          <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`px-2.5 py-1 rounded ${
                              currentPage === page
                                ? "bg-black text-white font-semibold"
                                : "bg-white border border-gray-300 hover:bg-gray-100"
                            }`}
                          >
                            {page}
                          </button>
                        );
                      }
                    )}
                    <button
                      disabled={currentPage === totalPages || totalPages === 0}
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
          {!isMatchFound && nearestStrategies.length > 0 && (
            <NoMatchSection nearestStrategies={nearestStrategies} fromGuest={true} />
          )}
          <div className="mt-4">
            <StockMatchSummary
              matchedStocks={matchedStocks}
              unmatchedStocks={unmatchedStocks}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default LoadStocksGuest;
